export const ORDER_STATUS = {
  '1': 'Open',
  '2': 'Closed',
  '3': 'Forced Closed'
};

const getOrderStatus = status => ORDER_STATUS?.[status] ?? '';

export default getOrderStatus;
